import React from 'react';

import { useTranslation } from '@hooks/useTranslations';

export type BankDetailsProps = {
  companyName?: string;
  bankName?: string;
  iban?: string;
  bic?: string;
};

const resolveValue = (propValue: string | undefined, localeValue: string | undefined): string => {
  if (propValue) {
    return propValue;
  }
  if (localeValue) {
    return localeValue;
  }
  return '';
};

const BankDetails: React.FC<BankDetailsProps> = ({
  companyName: propCompanyName,
  bankName: propBankName,
  iban: propIban,
  bic: propBic,
}) => {
  const { t } = useTranslation();

  // Props take precedence over locale-based details
  const companyName = resolveValue(
    propCompanyName,
    t('mzp.order.detail.payment.riverty.invoice.company.name'),
  );
  const bankName = resolveValue(
    propBankName,
    t('mzp.order.detail.payment.riverty.invoice.bank.name'),
  );
  const iban = resolveValue(propIban, t('mzp.order.detail.payment.riverty.invoice.iban'));
  const bic = resolveValue(propBic, t('mzp.order.detail.payment.riverty.invoice.bic'));

  if (!companyName && !bankName && !iban && !bic) {
    return null;
  }

  return (
    <div>
      <div>{companyName}</div>
      <div>{bankName}</div>
      <div>IBAN: {iban}</div>
      <div>SWIFT (BIC): {bic}</div>
    </div>
  );
};

export default BankDetails;
